/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 一个通用的事件桥，用于将任何函数包装起来以便后续调用。
 * 使用泛型来保持类型安全。
 */
class FJEventBridge {
    private _executeFunction: ((data: any) => void | undefined) | undefined;
    private readonly _bridgeTarget: string;

    get bridgeTarget(): string {
        return this._bridgeTarget;
    }

    constructor(props: { target: string }) {
        this._bridgeTarget = props.target;
    }

    public bindExecuteFunction(executeFunction?: (data: any) => void): void {
        this._executeFunction = executeFunction;
    }

    public execute(data?: any) {
        if (this._executeFunction) {
            return this._executeFunction(data);
        }
    }
}

export default FJEventBridge;
